import {
  ArrayField,
  Datagrid,
  Filter,
  FunctionField,
  List,
  ReferenceField,
  ResourceContextProvider,
  SearchInput,
  TextField,
} from "react-admin";
import SanitizedGrid from "../../../components/SanitizedGrid";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import _ from "lodash";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import LinkField from "../../changeRequestForms/components/LinkField";

interface IStudentList {
  routePlanId: number;
  levels: ILevel[];
}

const useStyles = makeStyles({
  root: {
    marginTop: 15,
  },
  header: {
    fontWeight: 600,
  },
  columnAddress: {
    width: "500px",
  },
});

const StudentFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const StudentList = ({ routePlanId, levels }: IStudentList) => {
  const classes = useStyles();
  const temp = _.cloneDeep(levels);
  const levelIds = temp.map((item: any) => {
    return item ? item.id : item;
  });

  return (
    <div className={classes.root}>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Student List</Typography>
        </Grid>
        <Grid item xs={12}>
          <ResourceContextProvider value="students">
            <List
              basePath={""}
              exporter={false}
              hasCreate={false}
              filters={<StudentFilter />}
              filterDefaultValues={{
                RoutePlanId: routePlanId,
                LevelIds: levelIds,
              }}
              bulkActionButtons={false}
              actions={null}
              sort={{ field: "RouteLocations", order: "DESC" }}
              title=" "
            >
              <Datagrid>
                <FunctionField
                  label="Student Name"
                  render={(record: any) => {
                    return <LinkField record={record} resource="students" />;
                  }}
                />
                <FunctionField
                  label="Address Info"
                  render={(record: any) => {
                    return (
                      <ArrayField source="routeLocations" fieldKey="id">
                        <Datagrid
                          empty={<Typography variant="body2">-</Typography>}
                        >
                          <FunctionField
                            label="Address"
                            headerClassName={classes.header}
                            cellClassName={classes.columnAddress}
                            render={(record: any) => {
                              return (
                                <>
                                  {record.blockNumber} {record.street}{" "}
                                  {record.postalCode}
                                </>
                              );
                            }}
                          />
                          <ReferenceField
                            label="Route"
                            headerClassName={classes.header}
                            reference="routes"
                            source="routeId"
                            linkType={false}
                          >
                            <TextField source="name" />
                          </ReferenceField>
                        </Datagrid>
                      </ArrayField>
                    );
                  }}
                />
                <FunctionField
                  label="Is Have Routes"
                  render={(record: any) => {
                    console.log(record);
                    return (
                      <>
                        {record.routeLocations.length > 0 ? (
                          <CheckCircleIcon />
                        ) : (
                          <CancelIcon />
                        )}
                      </>
                    );
                  }}
                />
              </Datagrid>
            </List>
          </ResourceContextProvider>
        </Grid>
      </SanitizedGrid>
    </div>
  );
};

export default StudentList;
